module.exports = __webpack_public_path__ + "@/assets/img/mail-error.e18f7724.svg";